// extracted by mini-css-extract-plugin
module.exports = {"item":"item_item__3TxWq","thumbnail":"item_thumbnail__2_VsR","data":"item_data__WigN6","date":"item_date__IUn33"};